import { useState, useCallback, useEffect } from 'react';
import fleetServices from 'services/fleet.services';

export default function useGetFleetInstantPayoutType() {
  const [loading, setLoading] = useState(false);
  const [listFleetInstantPayoutTypes, setListFleetInstantPayoutTypes] = useState([]);

  const getFleetInstantPayoutTypes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await fleetServices.listFleetInstantPayoutType();
      setListFleetInstantPayoutTypes(data.items);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getFleetInstantPayoutTypes();
  }, []);

  return {
    loading,
    listFleetInstantPayoutTypes,
    getFleetInstantPayoutTypes
  };
}
